import { render, staticRenderFns } from "./SupportCentersBlock.vue?vue&type=template&id=1db095bb"
import script from "./SupportCentersBlock.vue?vue&type=script&lang=js"
export * from "./SupportCentersBlock.vue?vue&type=script&lang=js"
import style0 from "./SupportCentersBlock.vue?vue&type=style&index=0&id=1db095bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports